const productDetailsInfo = {}

export default {
  productDetailsInfo
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-details/store/state.js